import { Box, Skeleton } from '@mui/material';

const SKELETON_ITEMS = [1, 2, 3, 4, 5, 6];

const ElectionCardSkeleton = () => {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '1rem',
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
      }}
    >
      {/* Header Section Skeleton */}
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        {/* Date Cluster Skeleton */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minWidth: '3rem',
            gap: 0.5,
          }}
        >
          <Skeleton variant="text" width="1.5rem" height="2rem" />
          <Skeleton variant="text" width="2rem" height="1rem" />
        </Box>

        {/* Info Column Skeleton */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width="60%" height="1rem" sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="80%" height="1.5rem" />
        </Box>

        {/* Avatar/Icon Skeleton */}
        <Skeleton
          variant="rectangular"
          width={44}
          height={44}
          sx={{ borderRadius: '0.75rem', flexShrink: 0 }}
        />
      </Box>

      {/* Candidates Section Skeleton */}
      <Box sx={{ p: 2, flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
        {[1, 2, 3, 4].map((i) => (
          <Box
            key={i}
            sx={{
              height: '2.5rem',
              width: '100%',
              bgcolor: 'action.hover',
              borderRadius: '0.375rem',
              display: 'flex',
              alignItems: 'center',
              px: 1.5,
              gap: 1.5,
            }}
          >
            {/* Percentage Placeholder */}
            <Skeleton variant="text" width="2rem" height="1.5rem" sx={{ flexShrink: 0 }} />
            {/* Avatar Placeholder */}
            <Skeleton variant="circular" width={24} height={24} sx={{ flexShrink: 0 }} />
            {/* Name Placeholder */}
            <Skeleton variant="text" width="50%" height="1.5rem" />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export const ElectionsSkeleton = () => {
  return (
    <Box
      sx={{
        py: { xs: 1, sm: 2 },
        width: '100%',
        maxWidth: '100vw',
        boxSizing: 'border-box',
        overflowX: 'hidden',
      }}
    >
      <Box sx={{ flex: 1, width: '100%', maxWidth: '100%' }}>
        {/* Page Title skeleton */}
        <Skeleton
          variant="rectangular"
          sx={{
            height: 48,
            borderRadius: '8px',
            mb: 4,
            maxWidth: 300,
            bgcolor: 'action.hover',
          }}
        />

        <Box
          sx={{
            display: 'grid',
            gap: 3,
            gridTemplateColumns: {
              xs: 'minmax(0, 1fr)',
              sm: 'minmax(0, 1fr)',
              md: 'repeat(2, minmax(0, 1fr))',
              lg: 'repeat(3, minmax(0, 1fr))',
            },
            width: '100%',
            maxWidth: '100%',
          }}
        >
          {SKELETON_ITEMS.map((itemKey) => (
            <ElectionCardSkeleton key={itemKey} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
